import { render, staticRenderFns } from "./Itens.vue?vue&type=template&id=01ef63a3&scoped=true&"
import script from "./Itens.vue?vue&type=script&lang=js&"
export * from "./Itens.vue?vue&type=script&lang=js&"
import style0 from "./Itens.vue?vue&type=style&index=0&id=01ef63a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef63a3",
  null
  
)

export default component.exports